
export default {
  layout: "empty",
  props: ["error"],
};
